import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Individual.css";
import "./Payment.css";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Explore from "./Explore";
// import SideNav from "./SideNav";
const Cablewire = () => {
  const [showTracker, setShowTracker] = useState(false);
useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="radial-bg"></div>
      <section className="insurance-service position-relative overflow-hidden">
        <div className="container">
          <div className="row">
            {/* <div className="col-lg-3  d-none d-lg-block">
              <div style={{ position: 'relative', height: '100%' }}>
               <SideNav /> 
            {/* </div>
            </div>  */}
            <div className="col-12">
          <div
            className="row justify-content-center text-center"
          >
            <div className="col-12">
              <h2 className="fw-semibold recharge-title">Cable Recharge</h2>
            </div>
          </div>

          <div className="row justify-content-center align-items-center" >
            <div className="col-12 col-md-8 col-lg-6">
              <div className="card shadow p-4 mb-5 recharge-box mt-5" style={{ minHeight: "20vh" }}>
                <div className="mb-3">
                  <label className="form-label fw-semibold">Cable TV Bill</label>
                  <select className="form-select">
                    <option value="">Select Provider</option>
                    <option>Tata Play (formerly Tata Sky)</option>
                    <option>Sun Direct</option>
                    <option>Dish TV</option>
                    <option>D2h (Videocon D2H)</option>
                    <option>Airtel Digital TV</option>
                    <option>KCCL (Kerala Communicators Cable Ltd)</option>
                    <option>DEN Odisha</option>
                    <option>Ortels Communications</option>
                    <option>Hathway Cable & Datacom</option>
                    <option>Den Networks</option>
                    <option>Siti Networks</option>
                    <option>GTPL Hathway</option>
                    <option>Digicable Network</option>
                    <option>InDigital (Induslnd Media)</option>
                    <option>Fastway Transmission</option>
                    <option>Asianet Digital TV</option>
                    <option>Kerala Vision Digital TV</option>
                    <option>
                      TCCL (Tamil Nadu Arasu Cable TV Corporation Limited)
                    </option>
                    <option>Manthan Broadband/Cable</option>
                    <option>WWIL (Wire and Wireless India Ltd)</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Mobile Number/Consumer No
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="Enter your mobile number"
                  />
                </div>
                <div className="d-grid">
                  <button
                    className="btn btn-primary"
                    style={{ fontFamily: "poppins" }}
                  >
                    Processed
                  </button>
                </div>

                <div className="mt-3" style={{ fontFamily: "poppins" }}>
                  <span>Status Pending?</span>
                  <br />
                  <button
                    className="btn btn-link text-decoration-none text-primary fw-semibold d-inline-flex align-items-center gap-1 p-0"
                    onClick={() => setShowTracker(!showTracker)}
                  >
                    Track Your Status now{" "}
                    <i className="bi bi-arrow-right-short fs-5"></i>
                  </button>

                  {showTracker && (
                    <div className="card p-3 mt-2 shadow-sm">
                      <label className="form-label">
                        Consumer Number / Mobile Number
                      </label>
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Enter Number To Track Your Status"
                      />
                      <button
                        className="btn btn-outline-primary"
                        style={{ fontFamily: "poppins" }}
                      >
                        Track Now
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="position-absolute bottom-0 start-0 end-0"
          style={{
            height: "25rem",
            background: "linear-gradient(to top, #F5F2FF, transparent)",
            zIndex: "-1",
          }}
        />
        </div>
        </div>
      </section>
      <Explore />
      <Footer />
    </>
  );
};

export default Cablewire;
